/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_1_1Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The documented macro-enabled save path preserves VBA without running it. Do not switch to .xlsx if the VBA project must remain.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档说明宏启用格式可保存 VBA，但不执行宏。需要保留 VBA 项目时，不要改存为 .xlsx。`)
};

/**
* | output |
* | --- |
* | "The documented macro-enabled save path preserves VBA without running it. Do not switch to .xlsx if the VBA project must remain." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_1_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_1_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_1_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Rows_1_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_1_1(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_1_1(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_3_table_rows_1_1 as "gc.search_guides.gridcraft_excel_compatibility.sections.3.table.rows.1.1" }